import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql, withApollo } from "react-apollo";
import '../institute_revision_material/_instRevisionMaterial.scss'

const ADD_REVISION_MATERIAL = gql`
  mutation($params: RevisionMaterial) {
    addRevisionMaterial(params: $params)
  }`

const FIN = {
    footer: { borderTop: "1px solid #f1f5f9", marginTop: 20, paddingTop: 20, display: "flex", flexDirection: "column", alignItems: "center" },
    label: { fontSize: 12, fontWeight: 600, color: "#374151", marginBottom: 5, display: "block" },
    input: { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "8px 12px", fontSize: 13, color: "#1f2937", background: "#f9fafb", width: "100%", height: 38 },
    err: { color: "#dc2626", fontSize: 12, marginTop: 4, display: "flex", alignItems: "center", gap: 5 },
    sectionHeader: { display: "flex", alignItems: "center", gap: 8, marginBottom: 16 },
    heading: { fontSize: 16, fontWeight: 800, color: "#1f2937", margin: 0, display: "flex", alignItems: "center", gap: 8 },
    // Shared btnBase recipe from the finance module (AccountsLedger.jsx / FeeStructureHome.jsx).
    btnBase: { border: "none", padding: "8px 16px", borderRadius: 8, fontWeight: 600, fontSize: 13, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, cursor: "pointer", boxShadow: "0 2px 4px rgba(0,0,0,0.05)", transition: "all 0.2s ease" },
    dropzone: { border: "2px dashed #e2e8f0", borderRadius: 12, padding: "26px 16px", textAlign: "center", background: "#f9fafb", cursor: "pointer", transition: "all 0.15s ease", minHeight: 220, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
    dropzoneActive: { borderColor: "#6366f1", background: "#eff6ff" },
    fileCard: { display: "flex", alignItems: "center", border: "1px solid #e5e7eb", borderRadius: 12, background: "#fff", padding: "12px 14px", minHeight: 220 },
    fileIcon: { width: 38, height: 38, borderRadius: 9, background: "#fee2e2", color: "#dc2626", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 17, flexShrink: 0, marginRight: 12 },
};

class RevisionMaterialUploadModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch_id: "",
            branchError: "",
            exam_id: "",
            examError: "",
            class_id: "",
            classError: "",
            subject_id: "",
            subjectError: "",
            chapter_id: "",
            chapterError: "",
            topic_id: "",
            topicError: "",
            title: "",
            titleError: "",
            file_uploading: "",
            fileError: "",
            selectedFile: null,
            fileUploadingInProgress: false,
            dragOver: false,
            getClasses: [],
            getSubjects: [],
            chapters: [],
            topics: [],
            loadingSpinner: 0,
            currentStep: 1,
            submitError: "",
            isSubmitting: false,
            existingmaterialId: ""
        }
    }

    async fileUpload(file, base64Data) {
        try {
            const response = await this.props.client.mutate({
                mutation: gql`
                    mutation FileUpload($params: FileUploadInput!) {
                        fileUpload(params: $params) {
                            uuid
                            file_url
                            file_extension_type
                            file_name
                        }
                    }
                `,
                variables: {
                    params: {
                        category: "materials",
                        client_id: parseInt(Cookies.get("institutionid")),
                        file: [{ img: base64Data, filename: file.name }]
                    }
                }
            });
            const fileUploadResult = response?.data?.fileUpload;
            return Array.isArray(fileUploadResult) ? fileUploadResult[0] : fileUploadResult;
        } catch (error) {
            console.error("File upload error:", error);
            throw error;
        }
    }

    // ── option builders (exam / branch -> class -> subject -> chapter -> topic) ──
    examOptions = () => (this.props.globals.exams || []).map(e => ({ value: e.id, label: e.exam }));

    classOptionsForBranch = (branchId) => {
        const b = (this.props.branches || []).find(x => String(x.id) === String(branchId));
        const sections = b ? (b.sections || []) : [];
        const classIds = [...new Set(sections.map(s => Number(s.class_id)))];
        const options = classIds
            .map(cid => (this.props.getClasses || []).find(c => c.id === cid))
            .filter(Boolean)
            .map(c => ({ value: c.id, label: c.class }));
        return this.filterClassesForEmployee(options);
    };

    // The employee row for the logged-in staff member, or null. getEmployees is scoped to
    // institute_id + branch_id server-side, so a branch_id cookie that disagrees with the
    // employee's own branch returns nothing — hence callers must treat null as "restrict",
    // never as "unrestricted" (see the fail-closed note below).
    loggedInEmployee = () => {
        const match = (this.props.getEmployees || []).filter((item) => item.employee_id == Cookies.get("id"));
        return match.length > 0 ? match[0] : null;
    };

    // Is this a staff login? Only userlevel 3 is restricted to assigned classes/subjects;
    // a main institute login (userlevel 1/2) is unrestricted and sees everything.
    isEmployeeLogin = () => Cookies.get("userlevel") == 3;

    // Restrict a class list to the ones a userlevel-3 employee is assigned to (via
    // employee.class_ids, same comma-separated convention as subject_ids).
    filterClassesForEmployee = (list) => {
        if (!this.isEmployeeLogin()) return list;
        const employee = this.loggedInEmployee();
        // Fail CLOSED: an unresolvable employee used to skip the filter entirely and hand a
        // staff login every class in the institute. Showing nothing is the safe direction —
        // it's visibly broken rather than silently over-permissive.
        if (!employee) {
            console.warn(`No employee row matched id=${Cookies.get("id")} in branch=${Cookies.get("branch_id")} — hiding all classes rather than showing every class.`);
            return [];
        }
        const allowed = new Set((employee.class_ids || "").split(",").map(s => s.trim()).filter(Boolean));
        return list.filter(o => allowed.has(String(o.value)));
    };

    // Restrict a subject list to the ones a userlevel-3 employee is assigned to. "General"
    // (0) is not an assignable subject and always stays available.
    filterForEmployee = (list) => {
        const dedupe = (l) => {
            const seen = new Set();
            return l.filter(o => (seen.has(o.value) ? false : (seen.add(o.value), true)));
        };
        if (!this.isEmployeeLogin()) return dedupe(list);
        const employee = this.loggedInEmployee();
        // Fail closed, same reasoning as filterClassesForEmployee.
        if (!employee) {
            console.warn(`No employee row matched id=${Cookies.get("id")} in branch=${Cookies.get("branch_id")} — restricting subjects to General.`);
            return dedupe(list.filter(o => o.value === 0));
        }
        const allowed = new Set((employee.subject_ids || "").split(",").map(s => s.trim()).filter(Boolean));
        return dedupe(list.filter(o => o.value === 0 || allowed.has(String(o.value))));
    };

    // Institute-wide subject list — every subject configured for this institute, regardless
    // of class or exam. globals.offlineExamSubjects is already institute-scoped server-side
    // (it's resolved from `class_subjects WHERE institute_id = ...`), so this never leaks
    // another institute's subjects.
    instituteSubjectOptions = () => {
        let list = [{ value: 0, label: "General" }];
        const offlineSubjects = this.props.globals.offlineExamSubjects || [];
        offlineSubjects.forEach(item => list.push({ value: item.id, label: item.subject }));
        return this.filterForEmployee(list);
    };

    // Subject list for an exam: the exam's own subjects intersected with the institute's.
    // exam_subjects comes from the global `exam.attributes` blueprint (see the Exam resolver)
    // and is NOT institute-scoped on its own — NEET lists Botany/Zoology whether or not this
    // institute teaches them — so it's only used to narrow instituteSubjectOptions(), never
    // as the list itself. Exam is optional on upload while Subject is required, so a blank
    // exam falls back to the full institute list rather than leaving the dropdown empty.
    subjectOptionsForExam = (examId) => {
        const instituteSubjects = this.instituteSubjectOptions();
        if (examId === "" || examId === undefined || examId === null) return instituteSubjects;
        const exam = (this.props.globals.exams || []).find(e => String(e.id) === String(examId));
        const examSubjectIds = new Set((exam?.exam_subjects || []).map(s => String(s.subject_id)));
        // An exam with no blueprint configured would otherwise intersect down to just
        // "General" — treat that as "no exam-level narrowing" instead of blocking upload.
        if (examSubjectIds.size === 0) return instituteSubjects;
        // "General" (0) is not an exam subject but must always stay selectable.
        return instituteSubjects.filter(o => o.value === 0 || examSubjectIds.has(String(o.value)));
    };

    chaptersFor = (subjectId, classId) => {
        const chapters = [{ value: 0, label: "Select..." }];
        const subj = (this.props.globals.subjects || []).find(s => s.id == subjectId);
        if (subj) {
            (subj.chapters || [])
                .filter(ch => Number(ch.class) === Number(classId))
                .forEach(ch => chapters.push({ value: ch.id, label: ch.chapter }));
        }
        return chapters;
    };

    // Topic list is sourced from globals.subjects[].chapters[].topics — nothing is
    // sent to the backend yet since RevisionMaterial input has no topic_id field.
    topicsFor = (subjectId, classId, chapterId) => {
        const topics = [{ value: 0, label: "Select..." }];
        const subj = (this.props.globals.subjects || []).find(s => s.id == subjectId);
        const chapter = subj && (subj.chapters || []).find(ch => Number(ch.class) === Number(classId) && ch.id == chapterId);
        if (chapter) {
            (chapter.topics || []).forEach(t => topics.push({ value: t.id, label: t.topic }));
        }
        return topics;
    };

    handleInputChange = e => {
        const { name, value } = e.target;

        // Exam drives the Subject list, so changing it rebuilds that list and clears any
        // subject (and its dependent chapter/topic) that the new exam may not cover.
        if (name == "exam") {
            this.setState({
                exam_id: value, examError: "",
                getSubjects: this.subjectOptionsForExam(value),
                subject_id: "", subjectError: "",
                chapter_id: "", chapterError: "", topic_id: "", topicError: "",
                chapters: [], topics: [],
            })
        }

        // Branch only rebuilds the Class list — the Subject list hangs off Exam, not Branch,
        // so it (and any chosen subject) survives a branch change. Chapters/topics are keyed
        // on class, so they reset with it.
        if (name == "branch") {
            if (value != "" && value != "--Select Branch--") {
                this.setState({
                    branch_id: value, branchError: "",
                    class_id: "", classError: "",
                    chapter_id: "", chapterError: "",
                    topic_id: "", topicError: "", topics: [],
                    getClasses: this.classOptionsForBranch(value),
                    chapters: []
                })
            } else {
                this.setState({
                    branch_id: "", branchError: "",
                    class_id: "", classError: "",
                    chapter_id: "", chapterError: "", topic_id: "", topicError: "", topics: [],
                    getClasses: [], chapters: []
                })
            }
        }

        // Class no longer narrows Subject — it only re-scopes the chapter list (chaptersFor
        // filters chapters by class), so an already-chosen subject is kept.
        if (name == "class") {
            const subjectId = this.state.subject_id;
            const keepsChapters = value != "0" && value != "--Select Class--" && subjectId != "" && subjectId != "0";
            this.setState({
                class_id: value, classError: "",
                chapters: keepsChapters ? this.chaptersFor(subjectId, value) : [],
                chapter_id: "", chapterError: "", topic_id: "", topicError: "", topics: [],
            })
        }

        if (name == "subject") {
            if (value != "" && value != "--Select Subject--") {
                if (value != "0") {
                    this.setState({
                        subject_id: value, subjectError: "",
                        chapters: this.chaptersFor(value, this.state.class_id),
                        chapter_id: "", chapterError: "", topic_id: "", topicError: "", topics: [],
                    })
                } else {
                    this.setState({
                        subject_id: value, subjectError: "",
                        chapters: [], chapter_id: "", chapterError: "",
                        topic_id: "", topicError: "", topics: [],
                    })
                }
            } else {
                this.setState({
                    subject_id: "", subjectError: "", chapters: [], chapter_id: "", chapterError: "",
                    topic_id: "", topicError: "", topics: [],
                })
            }
        }

        if (name == "chapter") {
            this.setState({
                chapter_id: value, chapterError: "",
                topics: this.topicsFor(this.state.subject_id, this.state.class_id, value),
                topic_id: "", topicError: "",
            })
        }

        if (name == "topic") {
            this.setState({ topic_id: value, topicError: "" })
        }

        if (name == "title") {
            this.setState({ title: value, titleError: "" })
        }
    };

    // ── file upload (drag & drop or browse) ──────────────────────────
    handleFileSelect = (file) => {
        if (!file) return;
        const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
        if (!isPdf) {
            this.setState({ fileError: "Please select a PDF file" });
            return;
        }
        this.setState({ selectedFile: file, fileError: "", fileUploadingInProgress: true, file_uploading: "" });
        const reader = new FileReader();
        reader.onload = async () => {
            const base64Data = reader.result;
            try {
                const upload = await this.fileUpload(file, base64Data);
                if (upload && upload.file_url) {
                    this.setState({ file_uploading: upload.file_url, fileError: "", fileUploadingInProgress: false });
                } else {
                    this.setState({ fileError: "An error occurred while uploading the file.", fileUploadingInProgress: false });
                }
            } catch (error) {
                this.setState({ fileError: "An error occurred while uploading the file.", fileUploadingInProgress: false });
            }
        };
        reader.readAsDataURL(file);
    };

    handleFileInputChange = (e) => {
        this.handleFileSelect(e.target.files[0]);
        e.target.value = "";
    };

    handleDragOver = (e) => { e.preventDefault(); this.setState({ dragOver: true }); };
    handleDragLeave = () => this.setState({ dragOver: false });
    handleDrop = (e) => {
        e.preventDefault();
        this.setState({ dragOver: false });
        this.handleFileSelect(e.dataTransfer?.files?.[0]);
    };
    removeFile = () => this.setState({ selectedFile: null, file_uploading: "", fileError: "", fileUploadingInProgress: false });

    handleFormSubmit = () => {
        // Exam, Chapter and Topic are optional — no validation for them.
        if (this.state.branch_id === "" || this.state.branch_id === "--Select Branch--") {
            this.setState({ branchError: "Please select branch" }); return;
        }
        if (this.state.class_id === "" || this.state.class_id === "--Select Class--") {
            this.setState({ classError: "Please select class" }); return;
        }
        if (this.state.subject_id === "" || this.state.subject_id === "--Select Subject--") {
            this.setState({ subjectError: "Please select Subject" }); return;
        }
        // Chapter and Topic are optional — no validation for them.
        if (this.state.title == "") {
            this.setState({ titleError: "Please Enter Title" }); return;
        }
        if (!(this.props.stateData?.individualMaterials?.length > 0)) {
            if (this.state.file_uploading == "") {
                this.setState({ fileError: "Please choose file" }); return;
            }
        }
        if (this.state.fileUploadingInProgress) {
            this.setState({ fileError: "Please wait for the file to finish uploading" }); return;
        }

        this.setState({ isSubmitting: true, loadingSpinner: 1 });

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch_id),
            exam_id: this.state.exam_id != "" && this.state.exam_id != undefined ? parseInt(this.state.exam_id) : null,
            class_id: parseInt(this.state.class_id),
            subject_id: parseInt(this.state.subject_id),
            chapter_id: this.state.chapter_id != "" && this.state.chapter_id != undefined && this.state.chapter_id != "0" ? parseInt(this.state.chapter_id) : null,
            file_name: this.state.title.toString(),
            file_path: this.state.file_uploading == "" || this.state.file_uploading == undefined ? "" : this.state.file_uploading,
            inserted_by: parseInt(Cookies.get("id")),
            existing_revisionMaterialId: this.state.existingmaterialId != "" && this.state.existingmaterialId != undefined ? this.state.existingmaterialId : null
        }

        this.addRevisionMaterial(params).catch(error => {
            this.setState({ submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0, isSubmitting: false });
        })
    };

    addRevisionMaterial = async (params) => {
        await this.props.addRevisionMaterial({
            variables: { params },
            update: (store, { data }) => {
                if (data.addRevisionMaterial) {
                    this.setState({ currentStep: 5, loadingSpinner: 0 })
                    setTimeout(() => {
                        this.props.onDone();
                    }, 1000)
                }
            }
        });
    };

    // This is now a plain tab pane (not a react-bootstrap Modal kept alive across
    // open/close), so the parent mounts a fresh instance per tab visit — populate from
    // props once on mount instead of watching a `show` prop transition.
    componentDidMount() {
        const existingMaterialDetails = this.props.stateData.individualMaterials;
        if (existingMaterialDetails.length > 0) {
            const m = existingMaterialDetails[0];
            let chapters = [];
            if (m.chapter_id != "0") {
                chapters = this.chaptersFor(m.subject_id, m.class_id);
            }
            this.setState({
                branch_id: m.branch_id,
                exam_id: m.exam_id,
                getClasses: this.classOptionsForBranch(m.branch_id),
                class_id: m.class_id,
                // Deliberately the institute-wide list, not subjectOptionsForExam(m.exam_id):
                // it's guaranteed to contain the subject this material was saved with, even if
                // the exam blueprint changed since upload. Intersecting on mount could drop
                // the stored subject and silently blank the select. If the user changes Exam
                // themselves, handleInputChange applies the exam narrowing from there.
                getSubjects: this.instituteSubjectOptions(),
                subject_id: m.subject_id,
                chapters: chapters,
                chapter_id: m.chapter_id,
                topics: m.chapter_id != "0" ? this.topicsFor(m.subject_id, m.class_id, m.chapter_id) : [],
                title: m.file_name,
                file_uploading: m.file_path,
                existingmaterialId: m.id
            })
        } else {
            // Exam starts blank, so the Subject list starts as the full institute list —
            // picking an exam narrows it from there (see handleInputChange).
            this.setState({ getSubjects: this.subjectOptionsForExam("") });
            // Default the Branch select to the first branch — if there's only one it's
            // effectively auto-selected, and with several it saves the user a click.
            const branches = this.props.branches || [];
            if (branches.length > 0) {
                const branchId = branches[0].id;
                this.setState({
                    branch_id: branchId,
                    getClasses: this.classOptionsForBranch(branchId),
                });
            }
        }
    }

    renderFileZone() {
        const { selectedFile, file_uploading, fileUploadingInProgress, dragOver } = this.state;
        const fileName = selectedFile ? selectedFile.name : (file_uploading ? file_uploading.split('/').pop() : "");
        const fileSize = selectedFile ? `${(selectedFile.size / (1024 * 1024)).toFixed(2)} MB` : null;

        if (selectedFile || file_uploading) {
            return (
                <div style={FIN.fileCard}>
                    <div style={FIN.fileIcon}><i className="fas fa-file-pdf" /></div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <span style={{ display: "block", fontSize: 13, fontWeight: 700, color: "#1f2937", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{fileName}</span>
                        {fileUploadingInProgress ? (
                            <span style={{ fontSize: 12, color: "#6366f1", fontWeight: 600 }}><span className="spinner-border spinner-border-sm" style={{ width: 11, height: 11, marginRight: 5 }} />Uploading...</span>
                        ) : (
                            <span style={{ fontSize: 12, color: "#059669", fontWeight: 600 }}><i className="fas fa-check-circle" /> {fileSize ? `${fileSize} · ` : ""}Ready</span>
                        )}
                    </div>
                    {!fileUploadingInProgress && (
                        <button type="button" onClick={this.removeFile} style={{ background: "none", border: "none", color: "#dc2626", fontSize: 17, padding: 4, cursor: "pointer" }} title="Remove file">
                            <i className="fal fa-times-circle" />
                        </button>
                    )}
                </div>
            );
        }

        return (
            <div
                style={{ ...FIN.dropzone, ...(dragOver ? FIN.dropzoneActive : {}) }}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
                onDrop={this.handleDrop}
                onClick={() => this.fileInput && this.fileInput.click()}
            >
                <input ref={(r) => (this.fileInput = r)} type="file" accept=".pdf" style={{ display: "none" }} onChange={this.handleFileInputChange} />
                <i className="fal fa-cloud-upload" style={{ fontSize: 30, color: "#6366f1", marginBottom: 8, display: "block" }} />
                <span style={{ fontSize: 13, fontWeight: 700, color: "#1f2937", display: "block" }}>Drag &amp; drop your PDF here</span>
                <span style={{ fontSize: 11, color: "#9ca3af", marginTop: 3, display: "block" }}>or click to browse from your device</span>
            </div>
        );
    }

    render() {
        const isEdit = this.props.stateData?.individualMaterials?.length > 0;
        return (
            <div>
                <div>
                    <div style={FIN.sectionHeader}>
                        <p style={FIN.heading}><i className="fal fa-upload" style={{ color: "#6366f1" }} />Upload Details</p>
                    </div>
                    <Row>
                        <Col lg={8} md={12} className="mb-3">
                            <Row>
                                <Col md={4} sm={12} className="mb-3">
                                    <label style={FIN.label}>Branch</label>
                                    <select style={FIN.input} name="branch" onChange={this.handleInputChange} value={this.state.branch_id}>
                                        <option value="">--Select Branch--</option>
                                        {(this.props.branches || []).map((b) => (
                                            <option key={b.id} value={b.id}>{b.branch_name}</option>
                                        ))}
                                    </select>
                                    {this.state.branchError ? <span style={FIN.err}><i className="fal fa-exclamation-circle" />{this.state.branchError}</span> : null}
                                </Col>
                                <Col md={4} sm={12} className="mb-3">
                                    <label style={FIN.label}>Class</label>
                                    <select style={FIN.input} name="class" onChange={this.handleInputChange} value={this.state.class_id}>
                                        <option value="">--Select Class--</option>
                                        {this.state.getClasses.map((c) => (
                                            <option key={c.value} value={c.value}>{c.label}</option>
                                        ))}
                                    </select>
                                    {this.state.classError ? <span style={FIN.err}><i className="fal fa-exclamation-circle" />{this.state.classError}</span> : null}
                                </Col>
                                {/* Exam sits above Subject because it narrows the Subject list
                                    (see subjectOptionsForExam) — picking it after would silently
                                    reset a subject the user had already chosen. */}
                                <Col md={4} sm={12} className="mb-3">
                                    <label style={FIN.label}>Exam <span style={{ color: "#9ca3af", fontWeight: 500 }}>(optional)</span></label>
                                    <select style={FIN.input} name="exam" onChange={this.handleInputChange} value={this.state.exam_id}>
                                        <option value="">--Select Exam--</option>
                                        {this.examOptions().map((ex) => (
                                            <option key={ex.value} value={ex.value}>{ex.label}</option>
                                        ))}
                                    </select>
                                    {this.state.examError ? <span style={FIN.err}><i className="fal fa-exclamation-circle" />{this.state.examError}</span> : null}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4} sm={12} className="mb-3">
                                    <label style={FIN.label}>Subject</label>
                                    <select style={FIN.input} name="subject" onChange={this.handleInputChange} value={this.state.subject_id}>
                                        <option value="">--Select Subject--</option>
                                        {this.state.getSubjects.map((s) => (
                                            <option key={s.value} value={s.value}>{s.label}</option>
                                        ))}
                                    </select>
                                    {this.state.subjectError ? <span style={FIN.err}><i className="fal fa-exclamation-circle" />{this.state.subjectError}</span> : null}
                                </Col>
                                {this.state.chapters.length > 1 ? (
                                    <Col md={4} sm={12} className="mb-3">
                                        <label style={FIN.label}>Chapter <span style={{ color: "#9ca3af", fontWeight: 500 }}>(optional)</span></label>
                                        <select style={FIN.input} name="chapter" onChange={this.handleInputChange} value={this.state.chapter_id}>
                                            {this.state.chapters.map((ch) => (
                                                <option key={ch.value} value={ch.value}>{ch.label}</option>
                                            ))}
                                        </select>
                                        {this.state.chapterError ? <span style={FIN.err}><i className="fal fa-exclamation-circle" />{this.state.chapterError}</span> : null}
                                    </Col>
                                ) : null}
                                {this.state.topics.length > 1 ? (
                                    <Col md={4} sm={12} className="mb-3">
                                        <label style={FIN.label}>Topic <span style={{ color: "#9ca3af", fontWeight: 500 }}>(optional)</span></label>
                                        <select style={FIN.input} name="topic" onChange={this.handleInputChange} value={this.state.topic_id}>
                                            {this.state.topics.map((t) => (
                                                <option key={t.value} value={t.value}>{t.label}</option>
                                            ))}
                                        </select>
                                        {this.state.topicError ? <span style={FIN.err}><i className="fal fa-exclamation-circle" />{this.state.topicError}</span> : null}
                                    </Col>
                                ) : null}
                            </Row>
                            <Row>
                                <Col md={12} className="mb-3">
                                    <label style={FIN.label}>Enter Title</label>
                                    <input type="text" style={FIN.input} placeholder="Enter Title" name="title" value={this.state.title} onChange={this.handleInputChange} />
                                    {this.state.titleError ? <span style={FIN.err}><i className="fal fa-exclamation-circle" />{this.state.titleError}</span> : null}
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={4} md={12} className="mb-3">
                            <label style={FIN.label}>Upload File (PDF)</label>
                            {this.renderFileZone()}
                            {this.state.fileError ? <span style={FIN.err}><i className="fal fa-exclamation-circle" />{this.state.fileError}</span> : null}
                        </Col>
                    </Row>
                </div>
                <div style={FIN.footer}>
                    {this.state.currentStep == 5 ? (
                        <p style={{ color: "#059669", fontWeight: 600, marginBottom: 10 }}><i className="fas fa-check-circle" /> Successfully Uploaded</p>
                    ) : this.state.submitError ? (
                        <p style={{ color: "#dc2626", marginBottom: 10 }}>{this.state.submitError}</p>
                    ) : null}
                    <div style={{ display: "flex", gap: 10 }}>
                        <button
                            type="button"
                            style={{ ...FIN.btnBase, background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)", color: "#fff", opacity: this.state.isSubmitting ? 0.7 : 1, cursor: this.state.isSubmitting ? "not-allowed" : "pointer" }}
                            disabled={this.state.isSubmitting}
                            onClick={this.handleFormSubmit}
                        >
                            {this.state.loadingSpinner == 1 ? <span className="spinner-border spinner-border-sm" /> : <i className="fas fa-upload" />}
                            {isEdit ? "Save Changes" : "Upload"}
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(withApollo(
    graphql(ADD_REVISION_MATERIAL, {
        name: "addRevisionMaterial"
    })(RevisionMaterialUploadModal)));
